import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from '../../base/i18n/functions';
import DesktopPickerQualityPopup from "./DesktopPickerQualityPopup";
import { isNeedShowElectronOnlyElements } from "../../base/environment/utils_web";
import { toggleDesktopShareQualitySettings } from "../../settings/actions.web";
import { getDesktopShareQualitySettingsVisibility } from "../../settings/functions.any";
import { getWindowQueryData } from "../functions";
/**
 * React component for QualityPopover.
 *
 * @augments Component
 */
class DesktopPickerQualityButton extends Component {
    /**
     * Initializes a new QualityPopover instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this._onEscClick = this._onEscClick.bind(this);
        this._onClick = this._onClick.bind(this);
    }
    /**
     * Click handler for the more actions entries.
     *
     * @param {KeyboardEvent} event - Esc key click to close the popup.
     * @returns {void}
     */
    _onEscClick(event) {
        if (event.key === 'Escape' && this.props.isOpen) {
            event.preventDefault();
            event.stopPropagation();
            this._onClick();
        }
    }
    /**
     * Click handler for the more actions entries.
     *
     * @param {MouseEvent} e - Mouse event.
     * @returns {void}
     */
    _onClick(e) {
        const { onButtonClick, isOpen } = this.props;
        if (isOpen) {
            e?.stopPropagation();
        }
        onButtonClick();
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     */
    render() {
        const { t, screenShareHint, onClick } = this.props;
        const { isWebVersion } = getWindowQueryData();
        if (!isNeedShowElectronOnlyElements() && !isWebVersion) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement(DesktopPickerQualityPopup, { screenShareHint: screenShareHint, onClick: onClick },
            React.createElement("div", { className: 'desktop-picker-picker-quality-button', onClick: this._onClick }, `${t('screenshare.quality')} – ${screenShareHint === "detail" ? t('screenshare.high_readability_text.title') : t('screenshare.smooth_video.title')}`)));
    }
}
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {IReduxState} state - The Redux state.
 * @private
 * @returns {IProps}
 */
function _mapStateToProps(state) {
    return {
        isOpen: Boolean(getDesktopShareQualitySettingsVisibility(state)),
    };
}
const mapDispatchToProps = {
    onButtonClick: toggleDesktopShareQualitySettings
};
export default translate(connect(_mapStateToProps, mapDispatchToProps)(DesktopPickerQualityButton));
